import React, { Dispatch, SetStateAction } from 'react'

import toast from 'react-hot-toast'
import { FaCheckCircle } from 'react-icons/fa'
import { PiFileAudio, PiTrash, PiUploadSimple } from 'react-icons/pi'

import { ItemToUpload, ItemToUploadBtns, UploadedItemsBtn } from './style'
import { useStorage } from '../../../context'
import { AudioRef, FileItem } from '../../../types'
import ProgressBar from '../../ProgressBar'

const FilesToUploadList = ({
  userId,
  logUID,
  defaultValue,
  files,
  setFiles,
  updateLogData,
  uploadSingleFile,
}: {
  userId?: string
  logUID?: string
  defaultValue: AudioRef[]
  files: FileItem[]
  setFiles: Dispatch<SetStateAction<FileItem[]>>
  updateLogData: (files: AudioRef[] | undefined) => void
  uploadSingleFile: (fileItem: {
    id: string
    file: File
    progress: number
  }) => Promise<AudioRef | undefined>
}) => {
  const { deleteAudio, loadingStorage } = useStorage()

  // Eliminar un archivo subido individualmente
  const handleDeleteSingle = async (id: string) => {
    if (!userId || !logUID) return
    const target = files.find((f) => f.id === id)

    if (!target) return

    try {
      // Si ya está subido y tenés url/path, intentá borrarlo del storage
      if (target.url) {
        await deleteAudio(userId, logUID, target.path ?? target.url)
        // actualizar el array del padre removiendo ese audio
        const remaining = defaultValue.filter(
          (a) => (a.path ?? a.url) !== (target.path ?? target.url),
        )
        updateLogData(remaining.length ? remaining : undefined)
      }

      // En cualquier caso, quitamos de la lista UI
      setFiles((prev) => prev.filter((f) => f.id !== id))

      toast.success('Archivo eliminado')
    } catch (err) {
      console.error('FE - Error al eliminar archivo:', err)
      toast.error('Error al eliminar archivo')
    }
  }

  return (
    <>
      {files.map((f) => (
        <div key={f.id} style={{ width: '100%', padding: 10 }}>
          {/* fila */}
          <ItemToUpload>
            {f.uploaded && <FaCheckCircle fontSize={18} color="#43AC29" />}
            <p>{f.file.name}</p>

            <ItemToUploadBtns>
              {f.progress === 0 ? (
                <UploadedItemsBtn
                  $action="upload"
                  type="button"
                  onClick={() => uploadSingleFile(f)}
                  disabled={f.uploaded || loadingStorage}
                >
                  {f.uploaded ? <PiFileAudio /> : <PiUploadSimple />}
                </UploadedItemsBtn>
              ) : (
                <p>{Math.floor(f.progress)}%</p>
              )}
              <UploadedItemsBtn
                $action="delete"
                type="button"
                onClick={() => handleDeleteSingle(f.id)}
                disabled={loadingStorage}
                aria-label="eliminar"
              >
                <PiTrash className="icon" />
                {/* Eliminar */}
              </UploadedItemsBtn>
            </ItemToUploadBtns>
          </ItemToUpload>
          {/* barra */}
          <ProgressBar progress={f.progress} />
        </div>
      ))}
    </>
  )
}

export default FilesToUploadList
